import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-cancel-token',
    templateUrl: './cancel-token.component.html',
    styleUrls: ['./cancel-token.component.scss'],
    standalone: false
})
export class CancelTokenComponent {

  @Output("confirmClose") output_confirmCloseCancelToken = new EventEmitter<boolean>();


  confirm() {
    this.output_confirmCloseCancelToken.emit(true);
  }

  close() {
    this.output_confirmCloseCancelToken.emit(false);
  }


}
